<template>
  <div class="course_details">
    <div v-if="Data && !goExamPopShow" class="course_details_main">
      <div class="title">
        <!-- <div @click="gotoStudyCenter" class="user_canter">企业学习中心</div> -->

        <h3>{{Data.kcMc}}</h3>
        <p>课程时长：<span v-if="parseInt(Data.kcSc/3600) > 0">{{parseInt(Data.kcSc/3600)}}小时</span>
          {{parseInt(Data.kcSc%3600/60)}}分钟{{Data.kcSc%3600%60}}秒 </p>
      </div>
      <div class="video_warp">
        <video :src="Data.spUrl" :poster="Data.tpUrl" controls="controls" controlsList="nodownload" id="video"></video>
        <div class="video_item">
          <div class="item_title">{{Data.lxName}}培训课程</div>
          <div class="sub_title">当前播放</div>
          <div class="item">
            <div class="item_left">
              <img :src="Data.tpUrl" alt="">
            </div>
            <div class="item_right">
              <div class="item_text">{{Data.kcMc}}</div>
              <div class="item_time">时长: {{s_to_hs(Data.kcSc)}}</div>
            </div>
          </div>
          <div class="sub_title" v-if="videoList&&videoList.length>0">其他课程</div>
          <div class="item" v-for="(item,index) in videoList" :key="index" @click="hangleActive(item.kcId)">
            <div class="item_left">
              <img :src="item.kcPic" alt="">
            </div>
            <div class="item_right">
              <div class="item_text">{{item.kcMc}}</div>
              <div class="item_time">时长: {{s_to_hs(item.kcSc)}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="clearfix lesson" style="width: 100%;margin-top: 20px">
        <el-button-group style="float: right">
          <el-button v-if="lastLessonId" type="primary" size="small" icon="el-icon-arrow-left" @click="toLastLesson()">上一节课</el-button>
          <el-button v-if="nextLessonId" type="primary" size="small" @click="toNextLesson()">
            下一节课<i class="el-icon-arrow-right el-icon--right"></i>
          </el-button>
        </el-button-group>
      </div>

      <div class="kcJs" v-if="Data.kcJs">
        <div class="til">课程介绍</div>
        <p>{{Data.kcJs}}</p>
      </div>
    </div>
    <ksts @backGoVideo="backGoVideo" ref="kst" :kclx="kclx" :lxKsgn="lxKsgn"></ksts>
  </div>
</template>

<script type="text/ecmascript-6">
  import {
    cookie
  } from "@/common/js/cookies.js";
  import ksts from '@/components/exam/ksts'
  export default {
    name: "course_details",
    data() {
      return {
        Data: null,
        spxbXbjl: 0, //上一次看到哪里了
        timer: null,
        lastLessonId: null,
        nextLessonId: null,
        xs: 0, //已学学时
        TimeIn: null, //定时器
        kcId: null, //课程id
        kclx: null, //课程类型
        videoList: [], //右侧视频
        lxKsgn: null, //判断是否考试
        goExamPopShow: false, //时长够了去考试提示框
        qyId: null, //企业id
      }
    },
    mounted() {
      // 自动跳转流程
      let {
        sign
      } = this.$route.query;
      if (sign == 1) {
        let NEXT_DO_OBJ = JSON.parse(localStorage.getItem("NEXT_DO_OBJ"));
        this.kcId = NEXT_DO_OBJ.kcId;
        this.kclx = NEXT_DO_OBJ.lxId;
        this.qyId = NEXT_DO_OBJ.qyId;
        // 赋值后删除
        // localStorage.removeItem("NEXT_DO_OBJ");
      } else {
        this.kcId = this.$route.query.kcId;
        this.kclx = this.$route.query.lxId;
        this.qyId = this.$route.query.qyId;
      }

      // this.getData();
      // this.getRightVideo();
      let _self = this;
      // window.addEventListener('beforeunload',function(){
      //  this.taggedVideo();
      // })
      window.onbeforeunload = function(e) {
        _self.taggedVideo();
        // var e = window.event||e;
        // e.returnValue = ("确定离开当前页面吗？");
        // return true
      }
      //每隔十分钟请求一次获取总时间来判断要不要去考试
      this.TimeIn = setInterval(function() {
        _self.subKs();
        setTimeout(function() {
          _self.taggedVideo();
        }, 700)
      }, 10000)
    },
    // beforeRouteLeave(to, form, next) {
    // 	_self.taggedVideo();
    // 	setTimeout(function(){
    // 		next()
    // 	},500)

    // },
    methods: {
      //返回继续观看视频
      backGoVideo() {
        this.$refs.kst.ksShow = false;
        this.goExamPopShow = false;
      },
      //跳转学习中心
      gotoStudyCenter() {
        let routerUrl = this.$router.resolve({
          path: "/center",
          query: {
            lxId: this.kclx,
            qyId: this.qyId,
          },
        });
        window.open(routerUrl.href, "_blank");
      },
      // 点击切换视频
      hangleActive(kcid) {
        // console.log(kcid)
        // this.kcId = kcid;
        window.location.href = '/courseDetail?kcId=' + kcid + '&lxId=' + this.kclx + '&qyId=' + this.qyId;
        // this.getData();
      },
      // 右侧视频
      getRightVideo() {
        let _self = this;
        let ajax = _self.$http.create();
        const loading = _self.$loading({
          lock: true,
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0.5)'
        });
        ajax({
            method: "get",
            url: SOWINURL + "index/lxKc/recommend",
            params: {
              lxId: Number(this.kclx),
              kcId: Number(this.kcId)
            }
          })
          .then(function(json) {
            if (json.data.result == 1) {
              _self.videoList = json.data.data;
              // console.log(_self.videoList)
              _self.lastLessonId = 0;

              if (_self.videoList != null && _self.videoList.length > 1) {
                var i = 0;
                for (var k = 0; k < _self.videoList.length; k++) {
                  if (_self.videoList[k].kcId == _self.kcId) {
                    i = k;
                  }
                }
                if (i == 0) {
                  _self.lastLessonId = _self.videoList[_self.videoList.length - 1].kcId;
                  _self.nextLessonId = _self.videoList[1].kcId;
                } else {
                  if (i == _self.videoList.length - 1) {
                    _self.lastLessonId = _self.videoList[i - 1].kcId;
                    _self.nextLessonId = _self.videoList[0].kcId;
                  } else {
                    _self.lastLessonId = _self.videoList[i - 1].kcId;
                    _self.nextLessonId = _self.videoList[i + 1].kcId;
                  }
                }
                console.log(_self.lastLessonId);
                console.log(_self.nextLessonId);
              }
            } else {
              _self.$message({
                showClose: true,
                message: json.data.errorcode,
                type: "error"
              });
            }
            loading.close();
          })
          .catch(function(error) {
            console.log(error);
          });
      },

      s_to_hs(s) {
        //计算分钟
        //算法：将秒数除以60，然后下舍入，既得到分钟数
        var h;
        h = Math.floor(s / 60);
        //计算秒
        //算法：取得秒%60的余数，既得到秒数
        s = s % 60;
        //将变量转换为字符串
        h += '';
        s += '';
        //如果只有一位数，前面增加一个0
        h = (h.length == 1) ? '0' + h : h;
        s = (s.length == 1) ? '0' + s : s;
        return h + ':' + s;
      },

      //每隔十分钟请求一次获取总时间来判断要不要去考试
      subKs() {
        //已学学时
        let _self = this;
        let ajax = _self.$http.create();
        let data = {
          lxId: this.kclx
        };
        ajax({
          method: 'post',
          url: SOWINURL + 'XxKh/getEnterpriseCenter',
          data: data,
          headers: {
            'token': cookie.get("xyxf_token_qt")
          }
        }).then(function(json) {
          if (json.data.result == 1) {
            let list = json.data.data;
            // _self.xs = list.xxglYxxs;
            _self.lxKsgn = list.lxKsgn; //判断是否考试
            let xxglYxxsSecond = list.xxglYxxsSecond || 0;
            let totalPxSecond = list.totalPxSecond;
            if (xxglYxxsSecond >= totalPxSecond && list.lxKsgn == 1 && list.xxglSftg == 0) {
              document.getElementById('video').pause();
              clearInterval(_self.TimeIn);
              setTimeout(() => {
                _self.$refs.kst.ksShow = true;
                _self.goExamPopShow = true;
              }, 700)
            }
          } else {
            _self.$message({
              showClose: true,
              message: json.data.errorcode,
              type: 'error'
            });
          }
        }).catch(function(error) {
          console.log(error);
        });
      },
      toLastLesson() {
        window.location.href = '/courseDetail?kcId=' + this.lastLessonId + '&lxId=' + this.kclx;
      },
      toNextLesson() {
        // debugger
        window.location.href = '/courseDetail?kcId=' + this.nextLessonId + '&lxId=' + this.kclx;
      },
      getData: function() {
        // console.log(this.kcId)
        let _self = this;
        let ajax = _self.$http.create();
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        ajax({
          method: 'post',
          url: SOWINURL + 'XxKh/getVideoDetail',
          data: {
            kcId: _self.kcId
          },
          headers: {
            'token': cookie.get("xyxf_token_qt")
          }
        }).then(function(json) {
          if (json.data.result == 1) {
            _self.Data = json.data.data;
            _self.spxbXbjl = _self.Data.spxbXbjl;
            // _self.lastLessonId = _self.Data.lastLessonId;
            // _self.nextLessonId = _self.Data.nextLessonId;
            setTimeout(() => {
              let video = document.getElementById('video');
              let flagSeeked = false;
              video.currentTime = _self.Data.spxbXbjl;

              video.addEventListener('seek', function(e) {
                console.log('进度条开始移动了')
                clearInterval(_self.timer);
              })

              video.addEventListener('seeked', function(e) {
                flagSeeked = true;
                console.log('进度条已经移动到了新的位置' + flagSeeked);
                if (parseInt(video.currentTime) > _self.Data.spxbXbjl) {
                  if (_self.Data.spxbXbjl <= _self.spxbXbjl) {
                    video.currentTime = _self.spxbXbjl;
                  } else {
                    video.currentTime = _self.Data.spxbXbjl;
                  }
                }
                setTimeout(function() {
                  flagSeeked = false;
                }, 500)

              })

              video.addEventListener('play', function(e) {
                console.log('提示该视频正在播放中')
                _self.timer = setInterval(function() {
                  _self.Data.spxbXbjl = parseInt(video.currentTime);
                }, 1000)

              })

              video.addEventListener('ended', function(e) {
                console.log('视频播放完了')
                _self.taggedVideo();

                if (!flagSeeked) {
                  _self.$alert('课程看完啦！', '提示', {
                    confirmButtonText: '确定',
                  });
                }

              })


              video.addEventListener('pause', function(e) {
                console.log('暂停播放')
                _self.taggedVideo();
                clearInterval(_self.timer);
              })

              window.onblur = function(e) {
                console.log("未激活状态！")
                video.pause();
              }

            }, 1000);

          } else {
            _self.$message({
              showClose: true,
              message: json.data.errorcode,
              type: 'error'
            });
          }
          loading.close();

        }).catch(function(error) {
          console.log(error);
        });
      },
      taggedVideo: function() { //页面销毁时请求 或 视频播放完请求
        let _self = this;
        let ajax = _self.$http.create();
        let duration = parseInt(document.getElementById('video').duration);
        let currentTime = parseInt(document.getElementById('video').currentTime);

        ajax({
          method: 'post',
          url: SOWINURL + 'XxKh/taggedVideo',
          data: {
            kcId: _self.Data.kcId,
            spxbXbjl: currentTime,
            spxbSfkw: duration <= currentTime ? 1 : 0,
            lxId: _self.kclx
          },
          headers: {
            'token': cookie.get("xyxf_token_qt")
          }
        }).then(function(json) {
          if (json.data.result == 1) {
            // _self.Data = json.data.data;
          } else {
            _self.$message({
              showClose: true,
              message: json.data.errorcode,
              type: 'error'
            });
            if (json.data.result == 2) {
              setTimeout(() => {
                //登录失效删除token
                cookie.delete('xyxf_token_qt');
                window.location.href = SOWINURL + 'index/login';
              }, 2000);
            }
          }
        }).catch(function(error) {
          console.log(error);
        });
      },
    },
    components: {
      ksts
    },
    beforeDestroy() {
      this.taggedVideo();
    },
  }
</script>

<style scoped lang="less" type="text/less">
  .course_details_main{
  width: 1210px;
  margin: 0 auto 40px;
  .lesson .el-button--small{
    color: #fff;
  }
  .kcJs{
    margin-top: 40px;
    font-size: 20px;
    .til{
      line-height: 40px;
    }
    p{
      line-height: 22px;
      font-size: 16px;
      color: #67738b;
    }
  }

  .title{
    margin-bottom: 20px;
    .user_canter{
      width: 160px;
      cursor: pointer;
      height: 48px;
      line-height: 48px;
      background: #0076ff;
      font-size: 18px;
      color: #fff;
      float: right;
      text-align: center;
      border-radius: 24px;
      /*margin-top: 10px;*/
    }
    h3{
      font-weight: normal;
      height: 30px;
      line-height: 30px;
      font-size: 20px;
      color: #06103b;
    }
    p{
      height: 28px;
      line-height: 28px;
      font-size: 14px;
      color: #67738b;
      span{
        color: #fc7059;
        padding-left: 20px;
      }
    }
  }
  .video_warp{
    width: 1200px;
    height: 535px;
    display: flex;
    video{
      flex: 1;
      width: 860px;
      max-height: 600px;
      display: block;
      overflow: hidden;
    }
    .video_item{
      margin-left: 20px;
      width: 320px;
      background-color: #06172A;
      padding: 20px;
      overflow-y: auto;
      cursor: pointer;
      box-sizing: border-box;
      .item_title{
        font-size: 24px;
        font-weight: 500;
        margin-bottom: 43px;
        color: #fff;
      }
      .sub_title{
        font-size: 16px;
        font-weight: 500;
        margin-bottom: 20px;
        color: #fff;
      }
      .item{
        display: flex;
        margin-bottom: 20px;
        align-items: center;
        .item_left{
          img{
            display: block;
            width: 100px;
            height: 60px;
            object-fit: cover;
          }
        }
        .item_right{
          margin-left: 20px;
          color: #fff;
          .item_text{
            font-size: 16px;
            font-weight: bold;
          }
          .item_time{
            margin-top: 10px;
            font-size: 14px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/course/course_details.vue